import apiClient, { extractData } from "./client";

/** Public endpoint — no auth required. */
export async function fetchMobileVersion() {
  // Fail open quickly. A slow version check must not hold the shell on a
  // weak network; the default API timeout is much longer.
  const response = await apiClient.get("/mobile/version", {
    timeout: 8000,
    _skipWeakNetRetry: true,
  });
  return extractData(response);
}
